// getIsPrivateShowTicket.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import { livestreamTicketType } from '../resource/liveStreamConstants.js';

import getGoalData from '../selector/getGoalData.js';

/**
 * Select is private show ticket by product id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} productId - gift product id.
 * @param {string} fundingId - funding goal id.
 * @param {string} performingId - performing goal id.
 * @return {boolean|undefined} return true if product is private show ticket product.
 */
const getIsPrivateShowTicket = createCachedSelector(
  (state, productId, fundingId, performingId) =>
    getGoalData(state, [performingId, 'context'], 'ticket_product_id'),
  (state, productId, fundingId) =>
    getGoalData(state, [fundingId, 'context'], 'ticket_product_id'),
  (state, productId, fundingId) =>
    getGoalData(state, [fundingId, 'context'], 'ticket_product_type'),
  (state, productId) => productId,
  (
    performingTicketProductId,
    fundingTicketProductId,
    fundingTicketProductType,
    productId
  ) => {
    if (!fundingTicketProductId && !performingTicketProductId) {
      return;
    }
    return (
      performingTicketProductId === productId ||
      (fundingTicketProductId === productId &&
        fundingTicketProductType === livestreamTicketType.SHOW)
    );
  }
)((state, productId, performingId) => `${productId}:${performingId}`);

export default getIsPrivateShowTicket;
